// extracted by mini-css-extract-plugin
export default {"texto":"UsuarioNavbar_texto__dB-8t"};